import { useRef, useState, useEffect } from "react";
//import ceddLogo from "../../assets/cedd_icon.png";
import itw_logo from "../../assets/itw_logo.png";
import styles from "./ChatBotPage.module.css";
import { chatApi, RetrievalMode, Approaches, AskResponse, ChatRequest, ChatTurn, getCitationFilePath } from "../../api";
import { AnswerNoHead, AnswerError, AnswerLoading } from "../../components/Answer";
import { QuestionInput } from "../../components/QuestionInput";
import { UserChatMessage } from "../../components/UserChatMessage";
import { AnalysisPanel, AnalysisPanelTabs } from "../../components/AnalysisPanel";
import { Greeting } from "../../components/Greeting";

import { ClearChatButton } from "../../components/ClearChatButton";

const ChatBotPage = () => {
    const [excludeCategory, setExcludeCategory] = useState<string>("");

    const lastQuestionRef = useRef<string>("");
    const chatMessageStreamEnd = useRef<HTMLDivElement | null>(null);

    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [error, setError] = useState<unknown>();

    const [activeCitation, setActiveCitation] = useState<string>();
    const [activeAnalysisPanelTab, setActiveAnalysisPanelTab] = useState<AnalysisPanelTabs | undefined>(undefined);

    const [selectedAnswer, setSelectedAnswer] = useState<number>(0);
    const [answers, setAnswers] = useState<[user: string, response: AskResponse][]>([]);

    const handleCitationsClick = async (citation: string) => {
        const isurl: boolean = (citation.includes("http") || citation.includes("https"));
        if (isurl) {
            window.open(citation, "_blank", "noopener,noreferrer");
        } else {
            window.open(getCitationFilePath(citation), "_blank", "noopener,noreferrer");
        }
    };

    const makeApiRequest = async (question: string) => {
        lastQuestionRef.current = question;

        error && setError(undefined);
        setIsLoading(true);
        setActiveCitation(undefined);
        setActiveAnalysisPanelTab(undefined);
        try {
            const last_three_chat = answers.slice(-3);
            const history: ChatTurn[] = last_three_chat.map(a => ({ user: a[0], bot: a[1].answer }));
            const request: ChatRequest = {
                history: [...history, { user: question, bot: undefined }],
                approach: Approaches.ReadRetrieveRead,
                overrides: {
                    promptTemplate: undefined,
                    excludeCategory: excludeCategory.length === 0 ? undefined : excludeCategory,
                    top: 3,
                    retrievalMode: RetrievalMode.Hybrid,
                    semanticRanker: true,
                    semanticCaptions: false,
                    suggestFollowupQuestions: false
                }
            };
            const result = await chatApi(request);
            if (window.parent) {
                const chat_history = JSON.stringify([...answers, [question, result]]);
                const json_message = JSON.stringify({ command: "history", content: chat_history });
                window.parent.postMessage(json_message, "*");
                console.log("send history");
            }
            setAnswers([...answers, [question, result]]);
        } catch (e) {
            setError(e);
        } finally {
            setIsLoading(false);
        }
    };

    const clearChat = () => {
        lastQuestionRef.current = "";
        error && setError(undefined);
        setActiveCitation(undefined);
        setActiveAnalysisPanelTab(undefined);
        if (window.parent) {
            const json_message = JSON.stringify({ command: "delete", content: null });
            window.parent.postMessage(json_message, "*");
            console.log("send delete");
        }
        setAnswers([]);
    };

    window.addEventListener("message", (event) => {
        if (event.data) {
            try {
                lastQuestionRef.current = "history exist";
                error && setError(undefined);
                setActiveCitation(undefined);
                setActiveAnalysisPanelTab(undefined);
                console.log('start');
                setAnswers(JSON.parse(event.data));
                console.log('end');
            }
            catch (e) {
                setError(e);
            }
        }
    });

    useEffect(() => {
        if (window.parent) {
            const json_message = JSON.stringify({ command: "loaded", content: null });
            window.parent.postMessage(json_message, "*");
        }
    }, []);

    useEffect(() => chatMessageStreamEnd.current?.scrollIntoView({ behavior: "smooth" }), [isLoading]);

    const onExampleClicked = (example: string) => {
        makeApiRequest(example);
    };



    return (
        <div className={styles.layout}>
            <header className={styles.header} role={"banner"}>
                <div className={styles.headerContainer}>
                    <img src={itw_logo}
                        className={styles.logoAvater}
                    />
                    <h4>Chat bot</h4>
                    <ClearChatButton
                        onClick={() => {
                            clearChat();
                        }}
                        disabled={isLoading} />
                </div>
            </header>



            <div className={styles.container}>
                {/* <div className={styles.commandsContainer}>
                <ClearChatButton className={styles.commandButton} onClick={clearChat} disabled={!lastQuestionRef.current || isLoading} />
                <SettingsButton className={styles.commandButton} onClick={() => setIsConfigPanelOpen(!isConfigPanelOpen)} />
            </div> */}

                <div className={styles.chatRoot}>
                    <div className={styles.chatContainer}>
                        {!lastQuestionRef.current ? (
                            /*<div className={styles.chatMessageStream}>
                                <Greeting
                                    message="Hi! We are the Geotechnical Engineering Office of CEDD.
     How can I help you?"
                                />
                            </div>*/
                            <div className={styles.chatMessageStream}>
                                <Greeting
                                    message="Hi! We are ITW PP & F Korea Limited (ITW PPFK).
     How can I help you?"
                                />
                            </div>
                        ) : (
                            <div className={styles.chatMessageStream}>
                                {answers.map((answer, index) => (
                                    <div key={index}>
                                        <UserChatMessage message={answer[0]} />
                                        <div className={styles.chatMessageGpt}>
                                            <AnswerNoHead
                                                key={index}
                                                answer={answer[1]}
                                                isSelected={selectedAnswer === index && activeAnalysisPanelTab !== undefined}
                                                onCitationClicked={c => {
                                                    handleCitationsClick(c);
                                                }}
                                            /> </div>
                                    </div>
                                ))}
                                {isLoading && (
                                    <>
                                        <UserChatMessage message={lastQuestionRef.current} />
                                        <div className={styles.chatMessageGptMinWidth}>
                                            <AnswerLoading />
                                        </div>
                                    </>
                                )}
                                {error ? (
                                    <>
                                        <UserChatMessage message={lastQuestionRef.current} />
                                        <div className={styles.chatMessageGptMinWidth}>
                                            <AnswerError error={error.toString()} onRetry={() => makeApiRequest(lastQuestionRef.current)} />
                                        </div>
                                    </>
                                ) : null}
                                <div ref={chatMessageStreamEnd} />
                            </div>
                        )}

                        <div className={styles.chatInput}>
                            <QuestionInput
                                clearOnSend
                                placeholder="Type a new question ..."
                                disabled={isLoading}
                                onSend={question => makeApiRequest(question)}
                            />
                        </div>
                    </div>

                    {answers.length > 0 && activeAnalysisPanelTab && (
                        <AnalysisPanel
                            className={styles.chatAnalysisPanel}
                            activeCitation={activeCitation}
                            onActiveTabChanged={x => { }}
                            citationHeight="810px"
                            answer={answers[selectedAnswer][1]}
                            activeTab={activeAnalysisPanelTab}
                        />
                    )}

                </div>
            </div>
        </div>
    );
};
export default ChatBotPage;
